module.exports = __webpack_public_path__ + "img/eagleWingsLogo@1x.46903b90.webp";